import React from 'react';
import styled from '@emotion/styled';
import { ArrowLink } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';

export const StyledSecurityWaitTimesLink = styled(ArrowLink)``;

export const SecurityWaitTimesLink = () => {
	const { t } = useTranslation();
	const url = useUrlForPageId(PassengersPageId.SecurityWaitingTimes);

	return (
		<StyledSecurityWaitTimesLink href={url}>
			{t('flight_details_security_wait_times_link')}
		</StyledSecurityWaitTimesLink>
	);
};
